import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'

export function RouteErrorBoundary() {
  const error = useRouteError()
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : 'Something unexpected happened.'

  return (
    <main className="grid min-h-screen place-items-center bg-ink-950 px-6 text-white">
      <div className="max-w-md text-center">
        <p className="mb-3 text-sm font-bold uppercase tracking-[0.24em] text-mint-300">
          Route error
        </p>
        <h1 className="font-display text-4xl font-bold">We hit a roadblock.</h1>
        <p className="mt-4 text-white/65">{message}</p>
        <Link
          to="/"
          className="mt-8 inline-flex rounded-full bg-lime-300 px-5 py-3 text-sm font-bold text-ink-950"
        >
          Return home
        </Link>
      </div>
    </main>
  )
}
